// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.5 3 H12.5 C13.6 3 14.5 3.9 14.5 5 V11 C14.5 12.1 13.6 13 12.5 13 H3.5 C2.4 13 1.5 12.1 1.5 11 V5 C1.5 3.9 2.4 3 3.5 3 Z',
  'M3.95 5.65 H4.05 V5.75 H3.95 Z',
  'M6.62 5.65 H6.72 V5.75 H6.62 Z',
  'M9.28 5.65 H9.38 V5.75 H9.28 Z',
  'M11.95 5.65 H12.05 V5.75 H11.95 Z',
  'M5.28 8.15 H5.38 V8.25 H5.28 Z',
  'M7.95 8.15 H8.05 V8.25 H7.95 Z',
  'M10.62 8.15 H10.72 V8.25 H10.62 Z',
  'M5 10.6 H11',
];
